import script from "./trust-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./trust-list.vue?vue&type=script&setup=true&lang=ts"

import "./trust-list.vue?vue&type=style&index=0&id=f541143e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f541143e"]])

export default __exports__